import React from 'react';
import { upperFirst } from 'lodash';
import { compose } from 'recompose';

import NotificationContent from '../../shared/AppointmentContainer';
import Header from './components/Header';
import Footer from '../../shared/Footer';
import Logo from '../../shared/Logo';
import PhonesBackground from '../../shared/PhonesBackground';
import SquireInfo from '../../shared/SquireInfo';
import PostCtaAction from './components/PostCtaAction';
import Cta from './components/Cta';
import withLoyaltyNotification from '../../hoc/withLoyaltyNotification';
import withAppointmentNotification from '../../hoc/withAppointmentNotification';
import LoyaltyIndicator from './components/Indicator';

/* eslint-disable react/prop-types */
const CustomerLoyaltyUpdate = ({
  shop,
  customer,
  appLink,
  isAmountBased,
  loyaltyAmountGoal,
  loyaltyTransactionsGoal,
  loyaltyProgress,
  loyaltyAmount,
  squireInfoClassName,
}) => (
  <div>
    <Header shopName={shop.name} />
    <NotificationContent>
      <Logo />
      <h2 className="u-text-huge u-fw-bold u-mt-10">
        Hey {upperFirst(customer.firstName)}, you’re halfway to your {loyaltyAmount} loyalty reward.
      </h2>
      <div className="u-mb-20 u-mt-12">
        <LoyaltyIndicator
          isAmountBased={isAmountBased}
          loyaltyAmountGoal={loyaltyAmountGoal}
          loyaltyTransactionsGoal={loyaltyTransactionsGoal}
          progress={loyaltyProgress}
        />
      </div>
      { shop.mobileAppCta && <Cta appLink={appLink} /> }
      { shop.mobileAppCta && <PhonesBackground name="rebook" /> }
      <div className={squireInfoClassName}>
        <SquireInfo
          standalone={!shop.mobileAppCta}
          shopName={shop.name}
          renderAction={PostCtaAction}
        />
      </div>
    </NotificationContent>
    <Footer link={appLink} />
  </div>
);

export default compose(
  withAppointmentNotification,
  withLoyaltyNotification,
)(CustomerLoyaltyUpdate);



// WEBPACK FOOTER //
// ./src/app/notifications/customer/CustomerLoyaltyUpdate/index.jsx